<template>
    <div class="page add-info" id="page">
        <div class="title">
            完善个人信息
        </div>

        <van-form class="add-info-form" @submit="onSubmit" ref="infoFrom">
            <van-field required label-class="form-title" input-align="right" v-model="formData.name" name="姓名" label="姓名" placeholder="姓名" :rules="[{ required: true},{validator: validatorStr, message: '格式错误'}]" error-message-align="right" scroll-to-error :show-error-message="false" />
            <div class="favorite">
                <div class="favorite-title"><span>*</span>身份类型</div>
                <van-radio-group v-model="formData.identity" class="favorite-content" @change="changeIdentity" checked-color="#D3172E">
                    <van-radio v-for="(item, index) in identity" :key="index" :name="item.id" :value="item.id" shape="round" @click="btnClickIdentity(item.id)">{{item.name}}<span class="other" v-if="item.id == IdentityType.Other && formData.identity == IdentityType.Other">{{formData.otherIdentityTypeName}}</span></van-radio>
                </van-radio-group>
            </div>
            <template v-if="formData.identity !== this.IdentityType.Other && formData.identity">
                <van-field required label-class="form-title" input-align="right" clickable readonly name="省市区" :value="formData.city_name" label="省市区" placeholder="请选择" @click="clickShowPicker('city')" :rules="[{ required: true}]" />
                <van-popup v-model="cityPicker" position="bottom">
                    <van-picker show-toolbar :columns="city" :value-key="'name'" @confirm="onCityConfirm" :loading="cityLoading" @cancel="cityPicker = false" />
                </van-popup>
            </template>

            <!-- 医务工作者 -->
            <template v-if="formData.identity == this.IdentityType.MedWorker">
                <van-field required label-class="form-title" input-align="right" clickable readonly name="医院名称" :value="formData.hospital_name" label="医院名称" placeholder="请选择" :rules="[{ required: true}]" @click="chooseHospital()" />

                <van-field required label-class="form-title" input-align="right" clickable name="科室" :value="formData.office_name" label="科室" placeholder="请选择" :rules="[{ required: true}]" @click="chooseOffice()" />

                <van-field required label-class="form-title" input-align="right" clickable readonly name="职称" :value="formData.position_name" label="职称" placeholder="请选择" :rules="[{ required: true}]" @click="clickShowPicker('position')" />
                <van-popup v-model="positionPicker" position="bottom">
                    <van-picker show-toolbar :columns="position" :value-key="'name'" :loading="positionLoading" @confirm="onPositionConfirm" @cancel="positionPicker = false" />
                </van-popup>

                <van-field label-class="form-title" input-align="right" v-model="formData.duty_name" name="职务" label="职务" placeholder="职务" :rules="[{validator: validatorDuty, message: '格式错误'}]"/>
            </template>
            <!-- 医疗企业相关人士 -->
            <template v-if="formData.identity == this.IdentityType.MedEntRelated">
                <van-field required label-class="form-title" input-align="right" clickable readonly name="所在机构类型" :value="formData.company_name" label="所在机构类型" placeholder="请选择" :rules="[{ required: true}]" @click="clickShowPicker('orgType')" />
                <van-popup v-model="orgTypePicker" position="bottom">
                    <van-picker show-toolbar :columns="orgType" :value-key="'name'" @confirm="onOrgTypeConfirm" @cancel="orgTypePicker = false" />
                </van-popup>
                <van-field required label-class="form-title" input-align="right" v-model="formData.hospital_name" name="单位名称" label="单位名称" placeholder="单位名称" :rules="[{ required: true },{validator: validatorStr, message: '格式错误'}]" />
                <van-field required label-class="form-title" input-align="right" v-model="formData.duty_name" name="职务" label="职务" placeholder="职务" :rules="[{ required: true },{validator: validatorStr, message: '格式错误'}]" />
            </template>

            <!-- 医学生 -->
            <template v-if="formData.identity == this.IdentityType.MedStudent">
                <van-field required label-class="form-title" input-align="right" clickable readonly name="院校名称" :value="formData.hospital_name" label="院校名称" placeholder="请选择" :rules="[{ required: true}]" @click="chooseSchool" />

                <van-field required label-class="form-title" input-align="right" clickable name="在读专业" :value="formData.office_name" label="在读专业" placeholder="请选择" :rules="[{ required: true}]" @click="chooseMajor" />
            </template>

            <!-- 其他 -->
            <template v-if="formData.identity == this.IdentityType.Other">
                <van-popup v-model="otherTypePicker" position="bottom">
                    <van-picker show-toolbar :columns="other" :value-key="'name'" @confirm="onOtherTypeConfirm" @cancel="otherTypePicker = false" />
                </van-popup>
                <!-- 患者/患者家属 -->
                <template v-if="formData.otherIdentityType == this.OtherType.Patient">
                    <van-field required label-class="form-title" input-align="right" clickable readonly name="确诊疾病" :value="formData.confirmed_disease_name" label="确诊疾病" placeholder="请选择" :rules="[{ required: true}]" @click="btnClickTag()" />


                    <div class="favorite">
                        <div class="favorite-title"><span>*</span>经历的治疗方式</div>
                        <checkbox-group v-model="formData.experience_treatment" class="favorite-content" @change="changeTrt" checked-color="#D3172E">
                            <checkbox :name="item.name" :value="item.id" v-for="item in treatment" :key="item.id"></checkbox>
                        </checkbox-group>
                    </div>
                </template>
                <!-- 公益组织 -->
                <template v-if="formData.otherIdentityType == this.OtherType.PWO">
                    <van-field required label-class="form-title" input-align="right" v-model="formData.hospital_name" name="组织名称" label="组织名称" placeholder="请输入" :rules="[{ required: true },{validator: validatorStr, message: '格式错误'}]" />
                </template>

                <!-- 媒体 -->
                <template v-if="formData.otherIdentityType == this.OtherType.Media">
                    <van-field required label-class="form-title" input-align="right" v-model="formData.hospital_name" name="单位名称" label="单位名称" placeholder="请输入" :rules="[{ required: true },{validator: validatorStr, message: '格式错误'}]" />
                </template>
            </template>


            <!-- <van-field
                label-class="form-title"
                input-align="right"
                v-model="formData.email"
                name="邮箱"
                label="邮箱"
                placeholder="请填写"
                :rules="[{ required: true }]"
            /> -->

            <!-- <div class="favorite" v-if="live_id == 727">
                <div class="favorite-title"><span>*</span>您与王院士的关系</div>
                <van-radio-group v-model="formData.friendship" class="favorite-content" @change="changeFriendship" checked-color="#D3172E">
                    <van-radio name="朋友" value="朋友" shape="round">朋友</van-radio>
                    <van-radio name="同事" value="同事" shape="round">同事</van-radio>
                    <van-radio name="后辈" value="后辈" shape="round">后辈</van-radio>
                    <van-radio name="弟子" value="弟子" shape="round">弟子</van-radio>
                </van-radio-group>
            </div> -->

            <div class="favorite van-hairline--bottom" v-if="formData.identity && formData.identity !== this.IdentityType.Other">
                <div class="favorite-title"><span>*</span>需求</div>
                <checkbox-group v-model="formData.tags" :max="5" class="favorite-content" @change="changeNeedTag" checked-color="#D3172E">
                    <checkbox :name="item.name" :value="item.id" v-for="item in needTags" :key="item.id"></checkbox>
                </checkbox-group>
            </div>

            <!-- 医务工作者 -->
            <template v-if="formData.identity == this.IdentityType.MedWorker">
                <div class="favorite van-hairline--bottom">
                    <div class="favorite-title"><span></span>擅长疾病</div>
                    <checkbox-group v-model="formData.good_at_disease" class="favorite-content" @change="changeDisease" checked-color="#D3172E">
                        <checkbox :name="item.name" :value="item.id" v-for="item in goodatDZTags" :key="item.id"></checkbox>
                    </checkbox-group>
                </div>

                <div class="favorite van-hairline--bottom">
                    <div class="favorite-title"><span></span>擅长诊疗技术</div>
                    <checkbox-group v-model="formData.good_at_technology" class="favorite-content" @change="changeTech" checked-color="#D3172E">
                        <checkbox :name="item.name" :value="item.id" v-for="item in goodatTechTags" :key="item.id"></checkbox>
                    </checkbox-group>
                </div>
            </template>


            <div class="clear"></div>

        </van-form>

        <div class="control">
            <van-button class="submit" color="#D3172E" round block type="info" native-type="submit" @click="addInfo()">完成</van-button>
        </div>

        <!-- 导流弹窗 -->
        <customer-dialog :show.sync="showCustomerVisible" @close="closeCustomerDialog">
        </customer-dialog>

        <!-- 患者标签 -->
        <select-tag :show.sync="dzShow" :disease="disease" :values="dzValues" @chooseTag="chooseTag"></select-tag>
    </div>
</template>

<script>
    import {
        IdentityType,
        OtherType
    } from "@/util/dict"
    import Interface from "@/util/interface"
    import checkbox from "@/components/checkbox/checkbox"
    import checkboxGroup from "@/components/checkbox/checkboxGroup"
    import selectTag from './components/selectTagNew.vue'
    import customerDialog from './components/customerDialog.vue'
    export default {
        name: 'home',
        components: {
            checkbox,
            checkboxGroup,
            selectTag,
            customerDialog
        },
        computed: {
            isEdit() {
                return this.$route.query && this.$route.query.update == 1
            },
            isUpdate() {
                return localStorage.getItem('update') || ''
            }
        },
        data() {
            return {
                value: "",
                active: 1,
                banners: [],
                recommend: [],
                articles: [],
                columns: [],
                live_id: 0,
                needTags: [],
                goodatDZTags: [],
                goodatTechTags: [],
                formData: {
                    name: '',
                    city_name: '',
                    city_id: 0,
                    province_id: 0,
                    province_name: '',
                    municipality_name: '',
                    municipality_id: 0,

                    company_name: '',
                    company_id: 0,

                    position_name: '',
                    position_id: 0,

                    hospital_name: '',
                    hospital_id: 0,
                    hospital_level_name: '',

                    office_id: 0,
                    office_name: '',

                    duty_name: '',

                    tags: [],
                    good_at_disease: [],
                    good_at_technology: [],
                    experience_treatment: [],
                    experience_treatment_name: '',

                    confirmed_disease: '',
                    confirmed_disease_name: '',

                    identity: '',
                    otherIdentityType: '',
                    otherIdentityTypeName: '',

                    // interested: "",
                    // email: "",
                    // friendship: "朋友",
                },

                status: false,
                backUrl: "",

                showArea: false,
                areaList: {},

                showPicker: false,

                position: [],
                positionPicker: false,
                positionLoading: false,

                city: [],
                cityPicker: false,
                cityLoading: false,

                office: [],
                officePicker: false,

                orgType: [],
                orgTypePicker: false,
                orgTypeLoading: false,

                showPositionVisible: false,
                positionInputValue: "",

                showCustomerVisible: false,

                identity: [],
                IdentityType: IdentityType,

                other: [],
                OtherType: OtherType,
                otherTypePicker: false,

                treatment: [],

                disease: [],
                diseasePicker: false,
                dzShow: false,
                dzValues: ''
            }
        },
        watch: {
            'formData.identity': {
                handler(newVal, oldVal) {
                    if (oldVal && oldVal != newVal) {
                        // 初始化
                        this.clearData(true)
                    }
                },
                immediate: false,
            },
            'formData.otherIdentityType': {
                handler(newVal, oldVal) {
                    if (oldVal && oldVal != newVal) {
                        // 初始化
                        this.clearData()
                    }
                }
            },
        },
        methods: {
            validatorDuty(val) {
                if(!val) {
                    return true
                } else {
                    return this.validatorStr(val)
                }

            },
            validatorStr(val) {
                if(/^(?![0-9]+$)(?!([a-zA-Z])\1+$).{2,}$/.test(val)) {
                    return true
                }
                return false
            },
            btnClickIdentity(id) {
                if(id == IdentityType.Other) {
                    this.otherTypePicker = true
                }
            },
            btnClickTag() {
                this.dzShow = true
                this.dzValues = this.formData.confirmed_disease
            },
            chooseTag(data) {
                let idStr = data
                    .filter((item) => !!item)
                    .map((item) => item.id)
                    .join(','),
                    nameStr = data
                    .filter((item) => !!item)
                    .map((item) => item.name)
                    .join(',')
                // 确诊疾病
                this.formData.confirmed_disease = idStr
                this.formData.confirmed_disease_name = nameStr
            },
            changeTrt(val) {
                if (!val.length) return
                this.formData.experience_treatment_name = this.treatment.map(item => {
                    if (val.includes(item.id)) return item.name
                }).filter((item) => !!item).join(',')
            },
            onSubmit() {},
            clickShowPicker(val) {
                if (val == 'city') {
                    this.fetch('city')
                    this.cityPicker = true
                } else if (val == 'position') {
                    this.fetch('position')
                    this.positionPicker = true
                } else if (val == 'orgType') {
                    this.fetch('orgType')
                    this.orgTypePicker = true
                }

            },
            fetch(scene) {
                if (scene == 'identity') {
                    return Interface.getData('get', Interface.user.identity).then(async (res) => {
                        this.identity = res.data
                        let ind = this.identity.findIndex(item => item.id == this.IdentityType.Other)
                        this.other = this.identity[ind].children
                    })
                } else if (scene == 'tags') {
                    Interface.getData('get', Interface.user.tags).then((res) => {
                        this.needTags = res.data.need
                        this.goodatDZTags = res.data.good_at_disease
                        this.goodatTechTags = res.data.good_at_technology
                    })
                } else if (scene === 'position') {
                    if (this.position.length) return
                    this.positionLoading = true
                    Interface.getData('get', Interface.user.title).then((res) => {
                        this.position = res.data.map(item => {
                            item.children = item.children || [{
                                name: ''
                            }]
                            return item
                        })
                        this.positionLoading = false
                    })
                } else if (scene === 'major') {
                    Interface.getData('get', Interface.user.major).then((res) => {
                        this.major = res.data
                    })
                } else if (scene === 'orgType') {
                    if (this.orgType.length) return
                    this.orgTypeLoading = true
                    Interface.getData('get', Interface.user.org).then((res) => {
                        this.orgType = res.data
                        this.orgTypeLoading = false
                    })
                } else if (scene === 'patient_tags') {
                    if (this.disease.length) return
                    Interface.getData('get', Interface.user.patient_tags).then((res) => {
                        // this.disease = []
                        // this.disease.push(...res.data.confirmed_disease)
                        this.disease = res.data.confirmed_disease
                        this.treatment = res.data.experience_treatment
                    })
                } else if (scene === 'city') {
                    if (this.city.length) return
                    this.cityLoading = true
                    Interface.getData('get', Interface.user.city).then((res) => {
                        this.city = res.data
                        this.cityLoading = false
                    })
                } else if (scene === 'office') {
                    Interface.getData('get', Interface.user.office, {
                        hospital_id: this.formData.hospital_id
                    }).then((res) => {
                        this.office = res.data
                    })
                } else if (scene === 'userinfo') {
                    Interface.getData('get', Interface.user.user_info).then((res) => {
                        // if (res.data.interested != null && res.data.interested != "") {
                        //     this.result = res.data.interested.split(",")
                        // }

                        this.formData = {
                            name: res.data.name,
                            city_name: this.handleCityStr(res.data),
                            // city_name: res.data.city_name,
                            city_id: res.data.city_id,
                            province_id: res.data.province_id,
                            province_name: res.data.province_name,
                            municipality_name: res.data.municipality_name,
                            municipality_id: res.data.municipality_id,

                            company_name: res.data.company_name,
                            company_id: res.data.company_id,

                            position_name: res.data.position_name,
                            position_id: res.data.position_id,

                            hospital_name: res.data.hospital_name,
                            hospital_id: res.data.hospital_id,
                            hospital_level_name: res.data.hospital_level_name,

                            office_id: res.data.office_id,
                            office_name: res.data.office_name,

                            interested: res.data.interested,
                            email: res.data.email,
                            friendship: res.data.friendship,

                            duty_name: res.data.duty_name,

                            tags: this.strToArr(res.data.tags),
                            good_at_disease: this.strToArr(res.data.good_at_disease),
                            good_at_technology: this.strToArr(res.data.good_at_technology),

                            confirmed_disease: res.data.confirmed_disease,
                            confirmed_disease_name: res.data.confirmed_disease_name,

                            experience_treatment_name: res.data.experience_treatment_name,
                            experience_treatment: this.strToArr(res.data.experience_treatment),

                            identity: Object.values(this.OtherType).includes(res.data.identity) ? this.IdentityType.Other : res.data.identity,
                            otherIdentityType: Object.values(this.OtherType).includes(res.data.identity) ? res.data.identity : '',
                            otherIdentityTypeName: '',
                        }


                        let cType = this.formData.otherIdentityType
                        if (cType) {
                            let citem = this.other.find(c => c.id == cType)
                            this.$set(this.formData, 'otherIdentityTypeName', citem.name)
                        }
                        console.log('initdata:', this.formData)
                        if(res.data.is_prompt == '1') {
                            this.$dialog.alert({
                                title: '提示',
                                message: '老朋友您好，欢迎回来，认证界面进行了一些改版，建议重新完善个人信息，如无需修改，您可点击完成',
                                confirmButtonText: "确认"
                            })
                        }

                        setTimeout(() => {
                            this.loading = false
                        }, 500)
                    })
                }
            },
            handleCityStr(obj) {
                let p = obj.province_name,
                    c = obj.city_name,
                    m = obj.municipality_name,
                    arr = [p, c, m].filter(item => item && item.trim()),
                    str = ''
                return str = !c ? '' : c.includes('/') ? c : arr.join('/')
            },
            strToArr(val) {
                return !val ? [] : val.split(',')
            },
            arrToStr(val) {
                return (val && Array.isArray(val) && val.length) ? val.join(',') : ''
            },
            onConfirm(values) {
                this.value = values
                    .filter((item) => !!item)
                    .map((item) => item.name)
                    .join('/');
                this.showArea = false;
            },
            onOrgTypeConfirm(val) {
                this.formData.company_name = val.name
                this.formData.company_type = val.id
                this.orgTypePicker = false
            },
            onPositionConfirm(values, index) {
                if (!values[1]) {
                    this.formData.position_name = this.position[index[0]].name
                    this.formData.position_id = this.position[index[0]].id
                } else {
                    this.formData.position_name = this.position[index[0]].children[index[1]].name
                    this.formData.position_id = this.position[index[0]].children[index[1]].id
                }
                this.positionPicker = false;

                // if (this.formData.position == '其他') {
                //     this.showPositionVisible = true
                // }
            },
            onCityConfirm(values, index) {
                this.formData.city_name = values
                    .filter((item) => !!item)
                    .map((item) => item)
                    .join('/');
                this.formData.province_id = this.city[index[0]].id
                this.formData.city_id = this.city[index[0]].children[index[1]].id
                this.formData.municipality_id = this.city[index[0]].children[index[1]].children[index[2]].id
                this.cityPicker = false;
            },
            onOtherTypeConfirm(value, index) {
                this.formData.otherIdentityType = value.id
                this.formData.otherIdentityTypeName = value.name
                this.otherTypePicker = false;
            },
            chooseHospital() {
                if (this.formData.city_id == 0) {
                    this.$toast.fail("请选择省市")
                    return
                }

                localStorage.setItem('add-info', JSON.stringify(this.formData))
                this.$router.push({
                    name: "choose-hospital",
                })
            },
            chooseSchool() {
                if (this.formData.city_id == 0) {
                    this.$toast.fail("请选择省市")
                    return
                }

                localStorage.setItem('add-info', JSON.stringify(this.formData))
                this.$router.push({
                    name: "choose-hospital",
                    query: {
                        isSchool: 1
                    }
                })
            },
            chooseMajor() {
                if (this.formData.hospital_id == 0) {
                    this.$toast.fail("请选择学校")
                    return
                }
                localStorage.setItem('add-info', JSON.stringify(this.formData))
                this.$router.push({
                    name: "choose-office",
                    query: {
                        isMajor: 1
                    }
                })
            },
            chooseOffice() {
                if (this.formData.hospital_id == 0) {
                    this.$toast.fail("请选择医院")
                    return
                }
                localStorage.setItem('add-info', JSON.stringify(this.formData))
                this.$router.push({
                    name: "choose-office",
                })
            },
            changeNeedTag(vals) {
                // console.log('检测到数据变化：', vals, this.formData.need)
                // this.formData.need = vals
            },
            changeDisease(vals) {
                // console.log('检测到数据变化2：', vals)
                // this.formData.good_at_disease = vals
            },
            changeTech(vals) {
                // console.log('检测到数据变化3：', vals)
                // this.formData.good_at_technology = vals
            },
            changeFavorite(values) {
                // this.formData.interested = values
                //     .filter((item) => !!item)
                //     .map((item) => item)
                //     .join(',');
            },
            changeIdentity(val, source = '') {
                // console.log('change:', val, source)
                // let ind = this.identity.findIndex(item => item.id == val)
                // this.formData.identity_name = this.identity[ind].name
                // 初始化
                // this.clearData()
            },
            clearData(pType = false) {
                Object.assign(this.formData, {
                    hospital_id: '',
                    hospital_name: '',
                    hospital_level_name: '',
                    office_id: '',
                    office_name: '',
                    duty_name: '',

                    position_name: '',
                    position_id: '',


                    // otherIdentityType: '',
                    // otherIdentityTypeName: '',

                    good_at_disease: [],
                    good_at_technology: [],
                    tags: [],

                    confirmed_disease: '',
                    confirmed_disease_name: '',

                    experience_treatment: [],
                    experience_treatment_name: '',

                    company_name: '',
                    company_type: '',
                })
                if (pType) {
                    this.formData.otherIdentityType = ''
                    this.formData.otherIdentityTypeName = ''

                    // this.formData.experience_treatment = []
                    // this.formData.experience_treatment_name = ''
                }
                console.log('cleardata')
            },
            changeFriendship(values) {
                this.$forceUpdate()
            },
            init() {
                let formData = localStorage.getItem('add-info') ? JSON.parse(localStorage.getItem('add-info')) : ''
                if (formData) {
                    let data = JSON.parse(localStorage.getItem('add-info'))
                    if (data.interested != null && data.interested != "") {
                        data.interested = data.interested.split(",")
                    }
                    Object.assign(this.formData, data)
                }
            },
            // 关闭导流页面跳转
            closeCustomerDialog() {
                this.showCustomerVisible = false
                this.skipPage()
            },
            skipPage() {
                setTimeout(() => {
                    let back = localStorage.getItem("back-url")
                    if (back != null) {
                        this.$router.push({
                            path: back,
                        })
                    } else {
                        this.$router.push({
                            name: "home",
                        })
                    }
                }, 500)
                if (this.isUpdate) {
                    Interface.mFootPrint(3, 42, '', '', 0, '我的-成功修改')
                } else {
                    Interface.mFootPrint(4, 43, '', '', 0, '成功提交')
                }
            },
            addInfo() {
                this.$refs['infoFrom'].validate().then(() => {
                    if(!this.formData.identity) {
                        this.$toast.fail(`身份类型不能为空`)
                        return
                    }
                    if (this.formData.identity !== this.IdentityType.Other && !this.formData.tags.length) {
                        this.$toast.fail(`需求不能为空`)
                        return
                    }
                    if (this.formData.otherIdentityType == this.OtherType.Patient && !this.formData.experience_treatment.length) {
                        this.$toast.fail(`治疗方式不能为空`)
                        return
                    }
                    let param = JSON.parse(JSON.stringify(this.formData)),
                        city = param.city_name.split('/')
                    // 其他-清空省市区
                    if(param.identity == this.IdentityType.Other) {
                        city = []
                        Object.assign(param,{
                            city_name: '',
                            city_id: '',
                            province_id: '',
                            province_name: '',
                            municipality_name: '',
                            municipality_id: '',
                        })
                    }
                    Object.assign(param, {
                        tags: this.arrToStr(param.tags),
                        good_at_disease: this.arrToStr(param.good_at_disease),
                        good_at_technology: this.arrToStr(param.good_at_technology),
                        // province_id: '',
                        province_name: city[0] || '',
                        // city_id: '',
                        city_name: city[1] || '',
                        // municipality_id: '',
                        municipality_name: city[2] || '',
                        identity: param.identity == this.IdentityType.Other ? param.otherIdentityType : param.identity,
                        experience_treatment: this.arrToStr(param.experience_treatment),
                        is_update: 1 // 点击确定 1、异常退出改页面为0
                    })

                    delete param.otherIdentityType
                    delete param.otherIdentityTypeName
                    Interface.getData('put', Interface.user.add_info, param).then(res => {
                        if (res.code === 0) {
                            localStorage.setItem("user", JSON.stringify(res.data))
                            localStorage.setItem("user_id", res.data.id)

                            // 注册成功-引流弹窗
                            if (!this.isUpdate) {
                                this.showCustomerVisible = true
                                return
                            }

                            // 编辑
                            this.$toast.success("提交成功");
                            this.skipPage()
                        } else {
                            this.error = true;
                            this.$toast.fail(res.message);
                            Interface.mFootPrint(5, 43, '', '', 0, '未成功提交')
                        }
                    })
                }).catch((err) => {
                    if(!err || !err.length) return
                    let msgstr = err[0].message || `${err[0].name}不能为空`
                    this.$toast.fail(msgstr);
                })
            }
        },

        async created() {
            await this.fetch('identity')
            this.fetch('tags')
            // this.fetch('position')
            // this.fetch('city')

            // this.fetch('orgType')
            // this.fetch('major')
            this.fetch('patient_tags')

            Interface.getShareInfo(this, "", "", "")


            let live_id = sessionStorage.getItem("live_id")
            if (live_id != null) {
                this.live_id = live_id
            } else {
                this.live_id = 0
            }
            if (this.isEdit) {
                this.fetch('userinfo')
            } else {
                this.init();
            }
            Interface.mFootPrint(3, 43, '', '', 0, '个人信息填写页')
        },
        beforeDestroy() {
            if(!this.isUpdate) {
                localStorage.setItem('add-info', JSON.stringify(this.formData))
            }
        }
    }
</script>

<style lang="scss">
    @import "./index-new.scss";
</style>



// WEBPACK FOOTER //
// src/views/login/add-info/index-new.vue